import CheckIcon from 'mdi-react/CheckIcon'
import { useSelector } from 'react-redux'

import { Translation } from '@/components/i18n/Translation'
import DataPoint, { DataPoints } from '@/components/primitives/DataPoint'
import { No, Yes } from '@/components/util/Polars'
import { getSubscriptionOrder } from '@/ducks/subscriptionOrderReducer'
import { getFormattedOrgNumber, getFormatterMobileNumber } from '@/util/formatters/text'
import { isOrderOfType, SUBSCRIPTION_ORDER_TYPES } from '@/util/orders'

const SubscriptionOrderUserDetails = () => {
  const order = useSelector(getSubscriptionOrder)
  const {
    user,
    code,
    user_comment,
    department_name,
    department_code,
    customer_name,
    customer_org_no,
    employee_number,
    id_number,
    email,
    cost_object_created,
    country_id,
    is_private_number,
  } = order
  const emailParts = email?.split('@')

  return (
    <section>
      <h3>
        <Translation id="User" />
      </h3>
      <DataPoints>
        <DataPoint
          header={<Translation id="Customer" />}
          value={
            <>
              {customer_name} ({customer_org_no && getFormattedOrgNumber(customer_org_no)})
            </>
          }
        />

        <DataPoint
          header={<Translation id="Department" />}
          value={`${department_code} ${department_name}`}
        />

        <DataPoint header={<Translation id="Name" />} value={user} />
        <DataPoint
          header={<Translation id="Employee number" />}
          value={`${employee_number || '—'}`}
        />

        <DataPoint
          header={<Translation id="Phone number" />}
          value={
            code ? (
              <>
                +{country_id} <Number code={code} cost_object_created={cost_object_created} />
              </>
            ) : (
              '—'
            )
          }
        />

        <DataPoint
          header={<Translation id="E-mail" />}
          value={
            emailParts && (
              <>
                {emailParts[0]}
                <wbr />@{emailParts[1]}
              </>
            )
          }
        />

        <DataPoint header={<Translation id="Comment" />} value={user_comment || '—'} />

        {isOrderOfType(order, SUBSCRIPTION_ORDER_TYPES.PORTING) && (
          <DataPoint header={<Translation id="ID number" />} value={id_number || '—'} />
        )}

        <DataPoint
          header={<Translation id="Private number" />}
          value={is_private_number ? <Yes /> : <No />}
        />
      </DataPoints>
    </section>
  )
}

const Number = ({ code, cost_object_created }: { code: string; cost_object_created: string }) => (
  <>
    {getFormatterMobileNumber(code)}
    {cost_object_created && <CheckIcon className="check" />}
  </>
)

export default SubscriptionOrderUserDetails
